// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function summary_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var is_portergold_active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_portergold_active"), null));
    if (is_portergold_active.TAG === /* Ok */0) {
      var mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
      if (mobile.TAG === /* Ok */0) {
        var address = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "address"), null));
        if (address.TAG === /* Ok */0) {
          var city = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
          if (city.TAG === /* Ok */0) {
            var uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "uuid"), null));
            if (uuid.TAG === /* Ok */0) {
              var referral = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "referral"), null));
              if (referral.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          name: name._0,
                          is_portergold_active: is_portergold_active._0,
                          mobile: mobile._0,
                          address: address._0,
                          city: city._0,
                          uuid: uuid._0,
                          referral: referral._0
                        }
                      };
              }
              var e = referral._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".referral" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = uuid._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".uuid" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = city._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".city" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = address._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".address" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = mobile._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".mobile" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = is_portergold_active._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".is_portergold_active" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function attributeData_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var attribute_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "attribute_name"), null));
  if (attribute_name.TAG === /* Ok */0) {
    var attribute_value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attribute_value"), null));
    if (attribute_value.TAG === /* Ok */0) {
      var is_editable = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_editable"), null));
      if (is_editable.TAG === /* Ok */0) {
        var is_verified = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_verified"), null));
        if (is_verified.TAG === /* Ok */0) {
          var attribute_note = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attribute_note"), null));
          if (attribute_note.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      attribute_name: attribute_name._0,
                      attribute_value: attribute_value._0,
                      is_editable: is_editable._0,
                      is_verified: is_verified._0,
                      attribute_note: attribute_note._0
                    }
                  };
          }
          var e = attribute_note._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".attribute_note" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = is_verified._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_verified" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = is_editable._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".is_editable" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = attribute_value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".attribute_value" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = attribute_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attribute_name" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function gstDetail_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var gstin = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "gstin"), null));
  if (gstin.TAG === /* Ok */0) {
    var gst_business_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "gst_business_name"), null));
    if (gst_business_name.TAG === /* Ok */0) {
      var gst_address = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "gst_address"), null));
      if (gst_address.TAG === /* Ok */0) {
        var updated_at = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
        if (updated_at.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    gstin: gstin._0,
                    gst_business_name: gst_business_name._0,
                    gst_address: gst_address._0,
                    updated_at: updated_at._0
                  }
                };
        }
        var e = updated_at._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".updated_at" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = gst_address._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".gst_address" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = gst_business_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".gst_business_name" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = gstin._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".gstin" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var summary = summary_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "summary"), null));
  if (summary.TAG === /* Ok */0) {
    var last_name = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_name"), null));
    if (last_name.TAG === /* Ok */0) {
      var first_name = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "first_name"), null));
      if (first_name.TAG === /* Ok */0) {
        var caller_type = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "caller_type"), null));
        if (caller_type.TAG === /* Ok */0) {
          var mobile = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
          if (mobile.TAG === /* Ok */0) {
            var secondary_mobile = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary_mobile"), null));
            if (secondary_mobile.TAG === /* Ok */0) {
              var company_name = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "company_name"), null));
              if (company_name.TAG === /* Ok */0) {
                var port_gold_status = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "port_gold_status"), null));
                if (port_gold_status.TAG === /* Ok */0) {
                  var geo_region = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region"), null));
                  if (geo_region.TAG === /* Ok */0) {
                    var email = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
                    if (email.TAG === /* Ok */0) {
                      var gstin = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "gstin"), null));
                      if (gstin.TAG === /* Ok */0) {
                        var gst_reg_address = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "gst_reg_address"), null));
                        if (gst_reg_address.TAG === /* Ok */0) {
                          var unconfirmed_email = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "unconfirmed_email"), null));
                          if (unconfirmed_email.TAG === /* Ok */0) {
                            var customer_type = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_type"), null));
                            if (customer_type.TAG === /* Ok */0) {
                              var temporarily_deactivated = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "temporarily_deactivated"), null));
                              if (temporarily_deactivated.TAG === /* Ok */0) {
                                var blacklist_reason = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "blacklist_reason"), null));
                                if (blacklist_reason.TAG === /* Ok */0) {
                                  var registration_status = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "registration_status"), null));
                                  if (registration_status.TAG === /* Ok */0) {
                                    var partload_customer = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "partload_customer"), null));
                                    if (partload_customer.TAG === /* Ok */0) {
                                      var subscribed_for_promo_sms = attributeData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscribed_for_promo_sms"), null));
                                      if (subscribed_for_promo_sms.TAG === /* Ok */0) {
                                        var is_business_customer = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_business_customer"), null));
                                        if (is_business_customer.TAG === /* Ok */0) {
                                          var gstin_list = Decco.optionFromJson((function (param) {
                                                  return Decco.arrayFromJson(gstDetail_decode, param);
                                                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "gstin_list"), null));
                                          if (gstin_list.TAG === /* Ok */0) {
                                            return {
                                                    TAG: /* Ok */0,
                                                    _0: {
                                                      summary: summary._0,
                                                      last_name: last_name._0,
                                                      first_name: first_name._0,
                                                      caller_type: caller_type._0,
                                                      mobile: mobile._0,
                                                      secondary_mobile: secondary_mobile._0,
                                                      company_name: company_name._0,
                                                      port_gold_status: port_gold_status._0,
                                                      geo_region: geo_region._0,
                                                      email: email._0,
                                                      gstin: gstin._0,
                                                      gst_reg_address: gst_reg_address._0,
                                                      unconfirmed_email: unconfirmed_email._0,
                                                      customer_type: customer_type._0,
                                                      temporarily_deactivated: temporarily_deactivated._0,
                                                      blacklist_reason: blacklist_reason._0,
                                                      registration_status: registration_status._0,
                                                      partload_customer: partload_customer._0,
                                                      subscribed_for_promo_sms: subscribed_for_promo_sms._0,
                                                      is_business_customer: is_business_customer._0,
                                                      gstin_list: gstin_list._0
                                                    }
                                                  };
                                          }
                                          var e = gstin_list._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".gstin_list" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                  }
                                                };
                                        }
                                        var e$1 = is_business_customer._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".is_business_customer" + e$1.path,
                                                  message: e$1.message,
                                                  value: e$1.value
                                                }
                                              };
                                      }
                                      var e$2 = subscribed_for_promo_sms._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".subscribed_for_promo_sms" + e$2.path,
                                                message: e$2.message,
                                                value: e$2.value
                                              }
                                            };
                                    }
                                    var e$3 = partload_customer._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".partload_customer" + e$3.path,
                                              message: e$3.message,
                                              value: e$3.value
                                            }
                                          };
                                  }
                                  var e$4 = registration_status._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".registration_status" + e$4.path,
                                            message: e$4.message,
                                            value: e$4.value
                                          }
                                        };
                                }
                                var e$5 = blacklist_reason._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".blacklist_reason" + e$5.path,
                                          message: e$5.message,
                                          value: e$5.value
                                        }
                                      };
                              }
                              var e$6 = temporarily_deactivated._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".temporarily_deactivated" + e$6.path,
                                        message: e$6.message,
                                        value: e$6.value
                                      }
                                    };
                            }
                            var e$7 = customer_type._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".customer_type" + e$7.path,
                                      message: e$7.message,
                                      value: e$7.value
                                    }
                                  };
                          }
                          var e$8 = unconfirmed_email._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".unconfirmed_email" + e$8.path,
                                    message: e$8.message,
                                    value: e$8.value
                                  }
                                };
                        }
                        var e$9 = gst_reg_address._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".gst_reg_address" + e$9.path,
                                  message: e$9.message,
                                  value: e$9.value
                                }
                              };
                      }
                      var e$10 = gstin._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".gstin" + e$10.path,
                                message: e$10.message,
                                value: e$10.value
                              }
                            };
                    }
                    var e$11 = email._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".email" + e$11.path,
                              message: e$11.message,
                              value: e$11.value
                            }
                          };
                  }
                  var e$12 = geo_region._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".geo_region" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                          }
                        };
                }
                var e$13 = port_gold_status._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".port_gold_status" + e$13.path,
                          message: e$13.message,
                          value: e$13.value
                        }
                      };
              }
              var e$14 = company_name._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".company_name" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                      }
                    };
            }
            var e$15 = secondary_mobile._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".secondary_mobile" + e$15.path,
                      message: e$15.message,
                      value: e$15.value
                    }
                  };
          }
          var e$16 = mobile._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".mobile" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
        }
        var e$17 = caller_type._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".caller_type" + e$17.path,
                  message: e$17.message,
                  value: e$17.value
                }
              };
      }
      var e$18 = first_name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".first_name" + e$18.path,
                message: e$18.message,
                value: e$18.value
              }
            };
    }
    var e$19 = last_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".last_name" + e$19.path,
              message: e$19.message,
              value: e$19.value
            }
          };
  }
  var e$20 = summary._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".summary" + e$20.path,
            message: e$20.message,
            value: e$20.value
          }
        };
}

export {
  summary_decode ,
  attributeData_decode ,
  gstDetail_decode ,
  t_decode ,
  
}
/* No side effect */
